<template>
  <p>
    <span style="font-size: 24px; font-weight: 700"> </span>
  </p>

  <br />
  <table cellspacing="0" class="tab-1" style="margin-top: -120px">
    <tbody>
      <tr>
        <td
          style="
            background-color: #d9d9d9;
            border-bottom: 1px solid black;
            border-left: 1px solid black;
            border-right: 1px solid black;
            border-top: 1px solid black;
            vertical-align: top;
          "
        >
          <p style="text-align: center">
            <span style="font-size: 10pt">
              <span style="font-family: 'SCDream'">개인정보 항목</span>
            </span>
          </p>
        </td>
        <td
          style="
            background-color: #d9d9d9;
            border-bottom: 1px solid black;
            border-left: none;
            border-right: 1px solid black;
            border-top: 1px solid black;
            vertical-align: top;
          "
        >
          <p style="text-align: center">
            <span style="font-size: 10pt">
              <span style="font-family: 'SCDream'">수집/이용 목적</span>
            </span>
          </p>
        </td>
        <td
          style="
            background-color: #d9d9d9;
            border-bottom: 1px solid black;
            border-left: none;
            border-right: 1px solid black;
            border-top: 1px solid black;
            vertical-align: top;
          "
        >
          <p style="text-align: center">
            <span style="font-size: 10pt">
              <span style="font-family: 'SCDream'">보유 및 이용기간</span>
            </span>
          </p>
        </td>
      </tr>
      <tr>
        <td
          style="
            border-bottom: 1px solid black;
            border-left: none;
            border-right: 1px solid black;
            border-top: none;
            vertical-align: middle;
          "
        >
          <p style="text-align: center">
            <span style="font-size: 10pt">
              <span style="font-family: 'SCDream'">
                성명, 생년월일, 아이디, 비밀번호,<br />
                이메일, 휴대폰 번호, 소속 학교 정보,<br />
                학번, 학부/학과 정보, 아바타 닉네임
              </span>
            </span>
          </p>
        </td>
        <td
          style="
            border-bottom: 1px solid black;
            border-left: none;
            border-right: 1px solid black;
            border-top: none;
            vertical-align: middle;
          "
        >
          <p style="text-align: center">
            <span style="font-size: 10pt">
              <span style="font-family: 'SCDream'">
                본인확인,<br />
                회원관리,<br />
                회원 특성에 따른 서비스 이용 통계
              </span>
            </span>
          </p>
        </td>
        <td
          style="
            border-bottom: 1px solid black;
            border-left: none;
            border-right: 1px solid black;
            border-top: none;
            vertical-align: middle;
          "
        >
          <p style="text-align: center">
            <span style="font-size: 10pt">
              <span style="font-family: 'SCDream'">
                <span style="font-weight: 700; text-decoration: underline"
                  >회원탈퇴시까지</span
                ><br />
              </span>
            </span>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <!-- <p style="margin-left: -50px"> -->
  <p>
    <span class="outerTxt" style="font-size: 16px">
      ※ 귀하는 개인정보 수집∙이용에 동의하지 않을 권리가 있으며, 동의 거부 시
      서비스 이용이 불가능합니다.
    </span>
  </p>
</template>
